import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import {useForm} from 'react-hook-form'
import PropTypes from 'prop-types'

import FormWrapper from '../../shared/FormWrapper'
import Input from '../../shared/Input'

/**
 * The two moments a recovery asks for a password, which are one form with different stakes.
 *
 * Both want the password set at the reset — the one the account signs in with now — and the person
 * being asked has two passwords in mind, having just been told that one of them no longer works.
 * Saying which one is meant is the whole job of the text under the field.
 */
const PasswordStep = ({error = '', ...props}) => {
  const methods = useForm()
  const {errors} = methods.formState

  return (
    <Paper elevation={3} component='div' className='recovery-step'>
      <Typography variant='h4' gutterBottom>{props.heading}</Typography>
      {props.children}
      {error.length > 0 && <Typography variant='body1' color='error' gutterBottom>{error}</Typography>}
      <FormWrapper methods={methods} handleSubmit={props.handleSubmit}>
        <Input
          error={!!errors.password}
          label='Password'
          name='password'
          type='password'
          options={{required: 'Password is required'}}
          helperText={errors.password?.message || 'The password you use to sign in now.'}
          margin='dense'
        />
        <Button disabled={props.loading} type='submit' variant='contained' sx={{color: '#F7F7F7'}}>
          {props.action}
        </Button>
      </FormWrapper>
    </Paper>
  )
}

PasswordStep.propTypes = {
  heading: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool
}

export default PasswordStep
